import { ForwardedRef, useImperativeHandle, useState } from 'react'

import { ModalActions } from '@/Shared/ui/Modal/atoms'

interface IUseModal {
  isOpen: boolean
  open: () => Promise<void>
  close: () => void
}

export const useModal = (
  ref: ForwardedRef<ModalActions>,
  openCallback: () => Promise<boolean> = async (): Promise<boolean> =>
    Promise.resolve(true),
): IUseModal => {
  const [isOpen, setOpen] = useState(false)

  const open = async (): Promise<void> => {
    const result = await openCallback()

    if (result) {
      setOpen(true)
    }
  }

  const close = (): void => {
    setOpen(false)
  }

  useImperativeHandle<ModalActions, ModalActions>(ref, () => ({
    open,
    close,
  }))

  return {
    isOpen,
    open,
    close,
  }
}
